import { action } from '@/lib/api.js';
import { store } from '@/redux/lib/configureStore.js';
import selectors from '@/redux/selectors/selectors.js';

const isValidObject = (obj) => obj && typeof obj === 'object' && Object.keys(obj).length > 0;

const hasValidId = (type, opts) => {
  const requiredIds = {
    workflow: { id: 'workflowId', message: 'Workflow ID is required' },
    app: { id: 'appId', message: 'App ID is required' },
    credential: { id: 'credentialId', message: 'Credential ID is required' },
    platformSecret: { id: 'platformSecretId', message: 'Platform Secret ID is required' },
    mockType: { id: 'mockTypeId', message: 'Mock Type ID is required' },
    issue: { id: 'issueId', message: 'Issue ID is required' },
    company: { id: 'companyId', message: 'Company ID is required' },
    workflowStep: { id: 'stepId', message: 'Step ID is required' },
    workflowSchedule: { id: 'stepId', message: 'Step ID is required' },
    project: { id: 'projectId', message: 'Project ID is required' },
    projectIssue: { id: 'issueId', message: 'Issue ID is required' },
    userPref: { id: 'userId', message: 'User ID is required' }
  };

  const requiredId = requiredIds[type];
  const isBatchOperation = ['addMany', 'delete'].includes(opts?.operation);

  if (requiredId && !opts?.[requiredId.id] && !isBatchOperation) {
    return { success: false, message: requiredId.message };
  }

  return { success: true };
};

const pushChangesQueueItem = (type, opts = {}, obj = {}) => {
  const state = store.getState();
  const companyId = selectors.companyId(state);

  const validId = hasValidId(type, opts);
  if (!validId.success) {
    console.error(validId.message);
    return;
  }

  if (type === 'app') {
    action('PUT_APP_AND_QUEUE_ITEM', { queueItem: { type, companyId, ...opts }, ...(isValidObject(obj) ? { app: obj } : {}) });
    return;
  }

  if (type === 'userPref') {
    action('PUSH_CHANGES_QUEUE_ITEM', { type, ...opts });
    return;
  }

  action('PUSH_CHANGES_QUEUE_ITEM', { type, companyId, ...opts });
};

export default pushChangesQueueItem;
